import type { Language } from "../../contexts/LanguageContext";

export const financialLabels: Record<Language, {
  title: string;
    tabs: {
    incomes: string;
    expenses: string;
    all: string;
  };
  summary: {
    incomes: string;
    expenses: string;
    balance: string;
    projection: string;
    netResult: string;
    forecast: string;
    insurancePayments: string;
    invoicesWaiting: string;
    batchAction: string;
  };
  methods: {
    pix: string;
    card: string;
    cash: string;
    transfer: string;
  };
  periods: {
    month: string;
    quarter: string;
    year: string;
    all: string;
  };
  filters: {
    all: string;
    paid: string;
    pending: string;
    insurance_pending: string;
    searchPlaceholder: string;
  };
  table: {
    client: string;
    type: string;
    amount: string;
    date: string;
    status: string;
    insurance: string;
    actions: string;
  };
  types: {
    monthly: string;
    per_consultation: string;
  };
  actions: {
    markAsPaid: string;
    stopRecurrence: string;
    delete: string;
    exportCsv: string;
  };
  breakdown: {
    title: string;
    specialty: string;
    method: string;
    amount: string;
  };
  trends: {
    title: string;
    lastMonths: string;
  };
  empty: string;
  loading: string;
  batch: {
    title: string;
    description: string;
    selectProvider: string;
    selectPayments: string;
    totalAmount: string;
    cancel: string;
    confirm: string;
    noProvider: string;
    noPayments: string;
  };
}> = {
  pt: {
    title: "Financeiro",
    tabs: {
      incomes: "Entradas",
      expenses: "Saídas",
      all: "Tudo",
    },
    summary: {
      incomes: "Entradas",
      expenses: "Saídas",
      balance: "Saldo do Período",
      projection: "Projeção de Caixa",
      netResult: "Resultado do mês",
      forecast: "Projeção do final do mês",
      insurancePayments: "Pagamentos de Convênio",
      invoicesWaiting: "faturas aguardando recebimento",
      batchAction: "Registrar Recebimento em Lote",
    },
    methods: {
      pix: "Pix",
      card: "Cartão",
      cash: "Dinheiro",
      transfer: "Transferência",
    },
    periods: {
      month: "Este Mês",
      quarter: "Últimos 3 Meses",
      year: "Este Ano",
      all: "Tudo",
    },
    filters: {
      all: "Todos",
      paid: "Pagos",
      pending: "Em aberto",
      insurance_pending: "Aguardando convenio",
      searchPlaceholder: "Buscar...",
    },
    table: {
      client: "Descrição / Cliente",
      type: "Tipo / Categoria",
      amount: "Valor",
      date: "Data/Vencimento",
      status: "Status",
      insurance: "Convênio",
      actions: "Ações",
    },
    types: {
      monthly: "Mensalidade",
      per_consultation: "Consulta Avulsa",
    },
    actions: {
      markAsPaid: "Marcar como pago",
      stopRecurrence: "Interromper recorrência",
      delete: "Excluir",
      exportCsv: "Exportar CSV",
    },
    breakdown: {
      title: "Detalhamento",
      specialty: "Por Especialidade",
      method: "Por Meio de Pagamento",
      amount: "Valor",
    },
    trends: {
      title: "Tendência",
      lastMonths: "Últimos 6 meses",
    },
    empty: "Nenhum registro encontrado.",
    loading: "Carregando dados financeiros...",
    batch: {
      title: "Registrar Pagamento de Convênio",
      description: "Selecione o convênio e as faturas a serem registradas.",
      selectProvider: "Convênio",
      selectPayments: "Selecione as faturas",
      totalAmount: "Valor total",
      cancel: "Cancelar",
      confirm: "Confirmar",
      noProvider: "Selecione um convênio",
      noPayments: "Nenhuma fatura selecionada",
    },
  },
  en: {
    title: "Financial",
    tabs: {
      incomes: "Incomes",
      expenses: "Expenses",
      all: "Both",
    },
    summary: {
      incomes: "Incomes",
      expenses: "Expenses",
      balance: "Period Balance",
      projection: "Cash Projection",
      netResult: "Net result",
      forecast: "Month-end forecast",
      insurancePayments: "Insurance Payments",
      invoicesWaiting: "invoices waiting for payment",
      batchAction: "Batch Register Payment",
    },
    methods: {
      pix: "Pix",
      card: "Card",
      cash: "Cash",
      transfer: "Transfer",
    },
    periods: {
      month: "This Month",
      quarter: "Last 3 Months",
      year: "This Year",
      all: "All Time",
    },
    filters: {
      all: "All",
      paid: "Paid",
      pending: "Pending",
      insurance_pending: "Waiting Insurance",
      searchPlaceholder: "Search...",
    },
    table: {
      client: "Description / Client",
      type: "Type / Category",
      amount: "Amount",
      date: "Date/Due",
      status: "Status",
      insurance: "Insurance",
      actions: "Actions",
    },
    types: {
      monthly: "Monthly Plan",
      per_consultation: "Per Consultation",
    },
    actions: {
      markAsPaid: "Mark as paid",
      stopRecurrence: "Stop recurrence",
      delete: "Delete",
      exportCsv: "Export CSV",
    },
    breakdown: {
      title: "Breakdown",
      specialty: "By Specialty",
      method: "By Payment Method",
      amount: "Amount",
    },
    trends: {
      title: "Trends",
      lastMonths: "Last 6 months",
    },
    empty: "No records found.",
    loading: "Loading financial data...",
    batch: {
      title: "Register Insurance Payment",
      description: "Select the insurance provider and invoices to register.",
      selectProvider: "Insurance Provider",
      selectPayments: "Select invoices",
      totalAmount: "Total amount",
      cancel: "Cancel",
      confirm: "Confirm",
      noProvider: "Select a provider",
      noPayments: "No invoices selected",
    },
  },
};
